import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-edicao-fta',
    templateUrl: './edicao-fta.component.html',
    styleUrls: ['./edicao-fta.component.css']
})
export class EdicaoFtaComponent implements OnInit {

    constructor() {
    }

    cols: any[];

    ngOnInit() {

        this.cols = [
            {field: 'fta', header: 'FTA'},
            {field: 'versao', header: 'Versão'},
            {field: 'nome', header: 'Nome'},
            {field: 'codTipoEstado', header: 'Cód. Tipo Estado'},
            {field: 'contratoIed', header: 'contratoIed'},
            {field: 'codTipoEstado', header: 'Cód. Tipo Estado'},
            {field: 'validade', header: 'Validade'}
        ];
    }
}



// WEBPACK FOOTER //
// ./src/app/edicao-fta/edicao-fta.component.ts